export default (crew) => crew ? `${crew.equipment ? crew.equipment.name : 'No Equipment'} ${crew.resources.filter(r => !!r.resource).map(r => ` / ${r.resource.firstName} ${r.resource.lastName}`).join('')}` : 'Unassigned';
